import SimpleTable from 'app/shared-components/SimpleTable'
import {
    Column,
} from 'app/types/simpletable.types'

type Props = {
    name: string,
    value?: Record<string, any>[],
    onChange: (...args: any[]) => void,
    columns: Column<any>[],
    addEntry: (...args: any[]) => void,
    deleteEntry: (...args: any[]) => void,
    inputs: (...args: any) => JSX.Element,
    disabled?: boolean,
}

const defaultProps: Partial<Props> = {
    value: [],
    disabled: false,
}
const Table = (props: Props) => {
    const {
        name,
        columns,
        value,
        onChange,
        addEntry,
        deleteEntry,
        inputs,
        disabled,
    } = props

    return (
        <SimpleTable
            name={name}
            columns={columns}
            data={value}
            component={inputs}
            addEntry={addEntry}
            onChange={onChange}
            onDelete={deleteEntry}
            disabled={disabled}
        />
    )
}

Table.defaultProps = defaultProps

export default Table
